/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserAccountType = {
    Ptw100: 'PTW100'
} as const;
export type UserAccountType = typeof UserAccountType[keyof typeof UserAccountType];


export function UserAccountTypeFromJSON(json: any): UserAccountType {
    return UserAccountTypeFromJSONTyped(json, false);
}

export function UserAccountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccountType {
    return json as UserAccountType;
}

export function UserAccountTypeToJSON(value?: UserAccountType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the UserAccountType interface.
 */
 export function instanceOfUserAccountType(value: any): value is UserAccountType {
    return Object.values(UserAccountType).includes(value)
}

